import React, { createContext, ReactElement, useState, useMemo, Dispatch, SetStateAction} from "react";
import { ProjetoPersonalizacaoType } from "../../types/ProjetoPersonalizacao";

interface ProjetoPersonalizacaoContextProps {
  projetoPersonalizacao: ProjetoPersonalizacaoType;
  setProjetoPersonalizacao: Dispatch<SetStateAction<ProjetoPersonalizacaoType>>
  stepAtual: number;
  setStepAtual: Dispatch<SetStateAction<number>>
  stepSelecionado: number;
  setStepSelecionado: Dispatch<SetStateAction<number>>
}

export const ProjetoPersonalizacaoContext = createContext({} as ProjetoPersonalizacaoContextProps);

export function ProjetoPersonalizacaoProvider({ children }: { children: ReactElement }) {
  const [projetoPersonalizacao, setProjetoPersonalizacao] = useState<ProjetoPersonalizacaoType>({} as ProjetoPersonalizacaoType)
  const [stepAtual, setStepAtual] = useState<number>(0)
  const [stepSelecionado, setStepSelecionado] = useState<number>(0)

  const values = useMemo(()=>{
    return{
      projetoPersonalizacao, 
      setProjetoPersonalizacao,
      stepAtual,
      setStepAtual,
      stepSelecionado,
      setStepSelecionado
    }
  },[projetoPersonalizacao, stepAtual, stepSelecionado])

  return (
      <ProjetoPersonalizacaoContext.Provider
        value={values}
      >
          {children}
      </ProjetoPersonalizacaoContext.Provider>
  );
}
